import { get } from './P3Api';

class CategoryMethodApi {
  static async getCategoryMethods(categoryId) {
    return get(`categories/${categoryId}/methods`);
  }
}

export default CategoryMethodApi;
